import { findKey } from "lodash";
import React from "react";
import ClassificationIcon from "../../../../../../components/ClassificationIcon";
import { getCuckooAndCapeClassification } from "../utils";

const CUCKOO_LIMITS = {
  UNKNOWN: 4,
  SUSPICIOUS: 7
};

const getCuckooResultIcon = score => {
  const classification = getCuckooAndCapeClassification(
    CUCKOO_LIMITS.UNKNOWN,
    CUCKOO_LIMITS.SUSPICIOUS,
    score
  );

  return (
    <>
      <ClassificationIcon classification={classification} />
      {score}
    </>
  );
};

const prepareCuckooResult = data => {
  if (!data.length) return null;

  const cuckooResultKey = findKey(data, o => o.key === "info");
  const cuckooErrorKey = findKey(data, o => o.key === "error_info");

  if (cuckooResultKey) {
    return getCuckooResultIcon(data[cuckooResultKey]?.value?.score);
  }
  if (cuckooErrorKey) return "Analysis failed";
  return null;
};

export { prepareCuckooResult };
